module.exports = __webpack_public_path__ + "static/media/BasierCircle-SemiBold.cb4a1a8e.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Basier Circle/Web/BasierCircle-SemiBold.woff
// module id = 6544
// module chunks = 1